import { render, staticRenderFns } from "./PolicyAndTerms.vue?vue&type=template&id=4c1484fc&scoped=true"
import script from "./PolicyAndTerms.vue?vue&type=script&lang=js"
export * from "./PolicyAndTerms.vue?vue&type=script&lang=js"
import style0 from "./PolicyAndTerms.vue?vue&type=style&index=0&id=4c1484fc&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c1484fc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/kemingchen/Projects/VisionFutureWeb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4c1484fc')) {
      api.createRecord('4c1484fc', component.options)
    } else {
      api.reload('4c1484fc', component.options)
    }
    module.hot.accept("./PolicyAndTerms.vue?vue&type=template&id=4c1484fc&scoped=true", function () {
      api.rerender('4c1484fc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/PolicyAndTerms.vue"
export default component.exports